import { createSlice } from "@reduxjs/toolkit";
type TInitialState = {
    empList:any[];
    empListLoading:boolean;
    empListFetching:boolean;
    empListIsError:boolean

}
export const empListInitialState: TInitialState = {
    empList:[],
    empListLoading:true,
    empListFetching:true,
    empListIsError:false
}
const empListSlice = createSlice({
    name: "empList",
    initialState: empListInitialState,
    reducers: {
        setEpmListData: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
    }
})

export const { setEpmListData } = empListSlice.actions;
export default empListSlice.reducer;
export const empListData = (state: any) => state?.empList;